module.exports = __webpack_public_path__ + "static/img/07.d62b64e0.png";